module.exports = __webpack_public_path__ + "img/polestar.161bd8fb.svg";